var R = require('ramda');
var m = require('mithril');
var d3 = require('d3');
var moment = require('moment');
var loaders = require('../../layout/components/loaders');
var Point = require('../../data/models/point');
var c3 = require('../../libs/chart');
var dateFormat = 'MM Do, h:mm a';

var chartByUnit = {};

chartByUnit.oninit = function (vnode) {
  var ctrl = this;
  ctrl.columns = vnode.attrs.columns;
  var columns = [];
  var hasBarGraph = false;

  ctrl.columns.forEach( column => {
    if (column.chartType === 'bar') {
      hasBarGraph = true
    }
    columns.push(['x', column.name]);
  })


  ctrl.chartData = {
    x: 'x',
    columns: columns
  };

  if (hasBarGraph) {
    ctrl.chartData.labels = {
      format: function (value) {
        return d3.format('.3s')(value);
      },
      size: 20
    }
  }

  ctrl.requestComplete = false;
  ctrl.chartLoadError = null;
  ctrl.loadedSeries = [];

  ctrl.loadChartData = function (data) {
    if (!ctrl.chart || !data) return;
    try {
      ctrl.chart.load(data);
    } catch (error) {
      // The chart is created after this component begins loading history.
      // Retry once without allowing a c3 timing error to escape as an
      // unhandled browser rejection.
      setTimeout(function () {
        try {
          if (ctrl.chart) ctrl.chart.load(data);
        } catch (retryError) {
          console.error('Unable to render unit chart:', retryError);
        }
      }, 500);
    }
  };

  ctrl.loadHistory = function () {
    var startTime = moment().valueOf();
    ctrl.chartLoadError = null;

    return Promise.all(ctrl.columns.map(function (column) {
      if (!column.in || typeof column.in['@rid'] === 'undefined') {
        return Promise.resolve({ data: null });
      }
      return loaders.requestWithLoader({
        url: '/api/v1/data/' + (column.in['@rid'].slice(1) || column.in['@rid']),
        method: 'GET',
        params: {
          start: startTime,
          span: /*ctrl.element.chartSpan ||*/ 8,
          resample: /*ctrl.element.chartResample ||*/ 'hours'
        },
        background: true,
        loader:'background'
      })
      .then(function (data) {
        return { data: data };
      })
      .catch(function (error) {
        console.error('Unable to load unit chart history:', error);
        return { error: error };
      });
    }))
    .then(function (results) {
      var hasFailures = false;
      results.forEach(function (result, idx) {
        if (result.error) {
          hasFailures = true;
          return;
        }

        var ts = result.data && result.data.data;
        if (!ts || !ts.columns || !Array.isArray(ts.values)) return;

        var rows = [];
        ts.values.forEach(function (row) {
          var colRecord = ctrl.columns[idx];
          if (row[1] == null) return;
          rows.push([row[0], Point.readValue({unit: colRecord.in.unit, destUnit: colRecord.in.destUnit, displayUnit: colRecord.in.displayUnit, value: row[1]}, true)]);
        });
        rows.shift();
        rows.unshift(['x', ctrl.columns[idx].name + ' (' + Point.formatUnit(ctrl.columns[idx].in) + ')']);
        var chartData = {
          type: ctrl.columns[idx].chartType || 'line',
          rows: rows
        };
        ctrl.loadedSeries[idx] = chartData;
        ctrl.loadChartData(chartData);
      });
      ctrl.chartLoadError = hasFailures ? 'Some chart history could not be loaded.' : null;
      ctrl.requestComplete = true;
      m.redraw();
      return results;
    })
    .catch(function (error) {
      console.error('Unable to load unit chart history:', error);
      ctrl.chartLoadError = 'Unable to load chart history.';
      ctrl.requestComplete = true;
      m.redraw();
      return null;
    });
  };

  ctrl.handleUpdate = function (data) {
    if (!ctrl.requestComplete) {return};
    if (data.rid == ctrl.point['@rid']) {
      if ((Date.now() - data.time) > 600000) {
        ctrl.chart.flow({
          rows: [
            ['x', ctrl.point.name],
            [data.time * 1000, Point.readValue({
              value: data.value,
              unit: ctrl.point.unit,
              destUnit: ctrl.point.destUnit,
              displayUnit: ctrl.point.displayUnit
            }, true)]
          ],
          length: 1
        });
      }
    };
  }

  ctrl.options = {
    data: ctrl.chartData,
    legend: {
      show: true
    },
    grid: {
      x: {
        show: true
      }
    },
    point: {
        show: false
    },
    tooltip: {
      show: false
    },
    axis: {
      y: {
        inner: true,
    	  tick: {
          count: 4,
          format: function (tick) {return parseFloat(tick.toFixed(4).replace(/\.?0+$/, ''))}
        }
      },
      x: {
        show: false,
        tick: {
          format: function (ts) { 
            var date = moment(Math.floor(ts / 1e3));
            return date.format(dateFormat);
          } 
        }
      }
    }
  };

  return ctrl.loadHistory();
}

chartByUnit.view = function() {
  var ctrl = this
  return m('div', [
    m(c3,{
      options: ctrl.options,
      oncreate: function (vnode) {
        ctrl.chart = vnode.state.chart;
        ctrl.loadedSeries.forEach(ctrl.loadChartData);
        vnode.attrs = ctrl.options;
      }
    }),
    ctrl.chartLoadError ? m('div.mt2.dark-red', [
      m('span', ctrl.chartLoadError + ' '),
      m('button', { type: 'button', onclick: ctrl.loadHistory }, 'Retry')
    ]) : null
  ])
};


module.exports = chartByUnit;
